import {Routes} from '@angular/router';
import {superuserGuard} from './core/guards/superuser.guard';
import {managedPracticeGuard} from './core/guards/managed-practice.guard';

export const routes: Routes = [
  // Calendar landing — resolves defaults and redirects to calendar page
  {
    path: '',
    loadComponent: () => import('./features/calendar/calendar-landing/calendar-landing.component').then(m => m.CalendarLandingComponent),
    pathMatch: 'full'
  },

  // Calendar page — full calendar with location/practice/practitioner context
  {
    path: 'calendar/:locationId/:practiceId/:practitionerId/:view/:year/:month/:day',
    loadComponent: () => import('./features/calendar/calendar-page/calendar-page.component').then(m => m.CalendarPageComponent)
  },

  // Management section — superuser only, with its own sidebar layout
  {
    path: 'management',
    loadComponent: () => import('./core/layout/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    canActivate: [superuserGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'organisation',
        loadComponent: () => import('./features/management/organisation-settings/organisation-settings.component').then(m => m.OrganisationSettingsComponent)
      },
      {
        path: 'locations',
        loadComponent: () => import('./features/management/location-management/location-management.component').then(m => m.LocationManagementComponent)
      },
      {
        path: 'locations/:locationId',
        loadComponent: () => import('./features/management/location-form/location-form.component').then(m => m.LocationFormComponent)
      },
      {
        path: 'practices',
        loadComponent: () => import('./features/management/practice-management/practice-management.component').then(m => m.PracticeManagementComponent)
      },
      {
        path: 'practices/new',
        loadComponent: () => import('./features/management/practice-management/add-practice-dialog/add-practice-dialog.component').then(m => m.AddPracticeDialogComponent)
      },
      {
        path: 'practices/:practiceId',
        canActivate: [managedPracticeGuard],
        loadComponent: () => import('./features/management/practice-detail/practice-detail.component').then(m => m.PracticeDetailComponent)
      },
      {
        path: 'users',
        loadComponent: () => import('./features/management/user-management/user-management.component').then(m => m.UserManagementComponent)
      },
      {
        path: 'billing',
        loadComponent: () => import('./features/management/billing-dashboard/billing-dashboard.component').then(m => m.BillingDashboardComponent)
      },
    ]
  },

  // Patient management — per-practice. If a user can see a practice's
  // calendar, they can view and edit its patients; managedPracticeGuard
  // gates only the management/config surface, not clinical access.
  // Any authenticated org user can read/write patients — no per-practice
  // permission lookup, no superuser gate. Patient *creation* is calendar-only:
  // the booking flow's new-patient dialog is the canonical entry. There is no
  // standalone "create patient" route or per-practice list page — discovery
  // happens via the toolbar omnisearch and creation via calendar booking.
  {
    path: 'practices/:practiceId/patients',
    children: [
      {
        path: ':profileId',
        loadComponent: () => import('./features/patients/view-patient/view-patient.component').then(m => m.ViewPatientComponent),
      },
      {
        path: ':profileId/edit',
        loadComponent: () => import('./features/patients/edit-patient/edit-patient.component').then(m => m.EditPatientComponent),
      },
    ]
  },

  {
    path: 'unauthorized',
    loadComponent: () => import('./core/layout/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./core/layout/error/error.component').then(m => m.ErrorComponent)
  }
];
